export const TYPES = {
    num: 'NUMBER',
    char: 'VARCHAR',
    currency: 'CURRENCY'
};

export const SORT = {
    asc: 'ASC',
    desc: 'DESC'
};
